export const deepEqual = (obj1, obj2) => {
  // Check if the objects are of the same type
  if (typeof obj1 !== typeof obj2) {
    return false;
  }

  // Check if the objects are null or primitive types
  if (obj1 === null || obj2 === null || typeof obj1 !== "object") {
    return obj1 === obj2;
  }

  // Get the keys of the objects
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // Check if the number of keys is the same
  if (keys1.length !== keys2.length) {
    return false;
  }

  // Check if all keys and their values are equal
  for (const key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
};
export const hasMoreThanKey = (obj) => {
  const keys = Object.keys(obj);  // Get all the keys of the object
  return keys.length > 1 || (keys.length === 1 && keys[0] !== 'key');
};

export const isJsonResponse = (response) => {
  if (typeof response === 'string') return false; 
  try {
      return typeof response === 'object' && response !== null
  } catch (e) {
      return false;
  }
};
export const prettyJson=(jsonString)=>{
  return JSON.stringify(jsonString, null, 2)
}